export default __webpack_public_path__ + "static/media/icon-fun.09bd20ea.png";